// Actions/setPassword.js
import axios from "axios";
import {jwtDecode} from "jwt-decode";

export const SET_PASSWORD_REQUEST = "SET_PASSWORD_REQUEST";
export const SET_PASSWORD_SUCCESS = "SET_PASSWORD_SUCCESS";
export const SET_PASSWORD_FAILURE = "SET_PASSWORD_FAILURE";

export const setPassword = (formData) => async (dispatch) => {
  dispatch({ type: SET_PASSWORD_REQUEST });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);

    const formDataToSend = {
      email: decodedToken.email,
      newPassword: formData.newPassword,
      reNewPassword: formData.confirmNewPassword,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/setPassword`,
      formDataToSend,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({ type: SET_PASSWORD_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: SET_PASSWORD_FAILURE,
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};
